import React from "react";
import App from "./App.jsx";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import AboutView from "./Views/AboutView/AboutView.jsx";
import BuyRentView from "./Views/BuyRentView/BuyRentView.jsx";
import RentView from "./Views/RentView/RentView.jsx";
import RandBView from "./Views/RandBView/RandBView.jsx";
import EducationView from "./Views/EducationView/EducationView.jsx";
import NewsView from "./Views/NewsView/NewsView.jsx";
import NewsAIView from "./Views/NewsAIView/NewsAIView.jsx";
import BuyView from "./Views/BuyView/BuyView.jsx";
import LandlordView from "./Views/LandlordView/LandlordView.jsx";
import UserView from "./Views/UserView/UserView.jsx";
import PassResetView from "./Views/PassResetView/PassResetView.jsx";
import ListingThankyouView from "./Views/LandlordView/ListingThankyouView.jsx";
import LandlordPaymentView from "./Views/LandlordView/LandlordPaymentView.jsx";
import LandlordPaymentSuccessView from "./Views/LandlordView/LandlordPaymentSuccessView.jsx";
import LandlordPaymentFailView from "./Views/LandlordView/LandlordPaymentFailView.jsx";
import AgencyView from "./Views/AgencyView/AgencyView.jsx";
import TandCView from "./Views/TandCView/TandCView.jsx";
import TestView from "./Views/Test/TestView.jsx";
import Edu from "./components/Edu/Edu.jsx";
import { useUtil } from "./contexts/UtilContext.jsx";

import styles from "./Routes.module.css"; // Updated for CSS modules
import ListingDetails from "./Views/ListingDetails/ListingDetails.jsx";
import TemplateDashboard from "./Views/TemplateDashboard/TemplateDashboard.jsx";
// import Dashboard from "./Views/Dashboard/Dashboard.jsx";
import RelatorOnboard from "./Views/onboard/RealtorOnboard/RelatorOnboard.jsx";
import RealtorLanding from "./Views/landing/Realtor/RealtorLanding.jsx";
import Portfolio from "./Views/Portfolio/Portfolio.jsx";
import Services from "./Views/Services/Services.jsx";
import Contact from "./Views/Contact/Contact.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProAddListing from "./Views/ProAddListing/ProAddListing.jsx";
import SingleRandBView from "./Views/SingleRandBView/SingleRandBView.jsx";
import LandlordLanding from "./Views/landing/Landlord/LandlordLanding.jsx";
import LandlordOnboard from "./Views/onboard/LandlordOnboard/LandlordOnboard.jsx";
import ProServiceChat from "./components/ProRealtorAI/ProRealtorAI.jsx";
import AdvertisementsBR from "./components/Advertisement/AdvertisementBR.jsx";
import UserLogin from "./components/UserLogin/UserLogin.jsx";
import AgencyOnboard from "./Views/onboard/AgencyOnboard/AgencyOnboard.jsx";
import AgnecyLanding from "./Views/landing/Agency/AgnecyLanding.jsx";
import DashHome from "./Views/Dashboard/DashHome/DashHome.jsx";
import DashAddAgency from "./Views/Dashboard/DashAddAgency/DashAddAgency.jsx";
import DashEditAgency from "./Views/Dashboard/DashEditAgency/DashEditAgency.jsx";
import EditListing from "./components/dashbaord/dashboardUtil/EditListing/EditListing.jsx";
import AdminHome from "./Views/admin/AdminHome/AdminHome.jsx";
import NewStory from "./components/dashbaord/DashProBlogs/DashProBlogsComponent/NewStory/NewStory.jsx";
import Bookmark from "./components/dashbaord/DashProBlogs/DashProBlogsComponent/Bookmark/Bookmark.jsx";
import BlogList from "./Views/BlogView/BlogList/BlogList.jsx";
import CourseList from "./Views/EduCourseView/CourseList.jsx";
import SubscriptionPage from "./Views/SubscriptionView/SubscriptionPage.jsx";
import ProBlogList from "./Views/BlogView/BlogList/ProBlogList.jsx";
import FlBlogList from "./Views/BlogView/BlogList/FlBlogList.jsx";
import ProReels from "./Views/ProReels/ProReels.jsx";
import SubscriptionSuccess from "./Views/SubscriptionView/SubscriptionSuccess.jsx";
import SubscriptionFailure from "./Views/SubscriptionView/SubscriptionFailure.jsx";
import ChatBotWrapper from "./components/ChatBotWrapper/ChatBotWrapper.jsx";
import Reservation from "./Views/ListingDetails/Reservation/Reservation.jsx";
import MarketInfo from "./components/Responsive/MarketInfo/MarketInfo.jsx";
import AddEmployee from "./components/AgencyAddEmployee/AgencyAddEmployee.jsx";
import CookiePolicyBanner from "./components/util/CookiePolicyBanner.jsx";
import GoogleAnalyticsLoader from "./components/util/GoogleAnalyticsLoader.jsx";
import SelectHouseView from "./Views/SelectHouseView/SelectHouseView.jsx";

export const AppRouter = () => {
  const { loader } = useUtil();
  return (
    <>
      <BrowserRouter>
        {/* Chat bot wrapper */}
        <ChatBotWrapper />

        <Routes>
          <Route path="/" element={<App />}></Route>
          <Route path="/About" element={<AboutView />}></Route>
          <Route path="/Buy-or-Rent" element={<BuyRentView />}></Route>
          <Route path="/Buy" element={<BuyView />}></Route>
          <Route path="/pro-service" element={<ProServiceChat />} />
          <Route path="/advertisementBR" element={<AdvertisementsBR />} />
          <Route
            path="/Buy-Homes/:listingUrl"
            element={<ListingDetails />}
          ></Route>
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/Rent" element={<RentView />}></Route>
          <Route
            path="Rent-Homes/:listingUrl"
            element={<ListingDetails />}
          ></Route>
          {/* <Route path="/Sell" element={<LandlordView />}></Route> */}
          <Route path="/Landlord" element={<LandlordView />}></Route>
          <Route path="/Portfolio" element={<Portfolio />}></Route>
          <Route path="/Services" element={<Services />}></Route>
          <Route path="/Contact" element={<Contact />}></Route>
          <Route
            path="/Landlord/Payment"
            element={<LandlordPaymentView />}
          ></Route>
          <Route
            path="/Landlord/Thankyou"
            element={<ListingThankyouView />}
          ></Route>
          <Route
            path="/Landlord/payment-success"
            element={<LandlordPaymentSuccessView />}
          ></Route>
          <Route
            path="/Landlord/payment-fail"
            element={<LandlordPaymentFailView />}
          ></Route>
          <Route path="/Realtors-and-Brokers" element={<RandBView />}></Route>
          <Route
            path="/Realtors-and-Brokers/:proSlug"
            element={<SingleRandBView />}
          ></Route>
          <Route path="/List-a-Property" element={<LandlordView />}></Route>
          <Route path="/Rent-a-Property" element={<RentView />}></Route>
          <Route path="/User" element={<UserView />}></Route>

          {/* Dasboard Routes */}
          <Route
            path="/MyFirstLand/agency/add"
            element={<DashAddAgency />}
          ></Route>

          <Route
            path="/MyFirstLand/agency/:id/edit"
            element={<DashEditAgency />}
          />
          <Route
            path="/MyFirstLand/employee/add"
            element={<AddEmployee />}
          ></Route>

          {/* <Route
            path="/MyFirstLand/listing/edit"
            element={<DashEditListing />}
          ></Route> */}
          <Route path="/MyFirstLand" element={<DashHome />}></Route>
          <Route path="/new-blog" element={<NewStory />} />
          <Route path="/bookmark" element={<Bookmark />} />

          <Route path="/blog-view" element={<BlogList />}></Route>
          <Route path="/courses" element={<CourseList />}></Route>
          <Route
            path="/subscription-plans"
            element={<SubscriptionPage />}
          ></Route>
          <Route
            path="/subscription/success"
            element={<SubscriptionSuccess />}
          ></Route>
          <Route
            path="/subscription/cancel"
            element={<SubscriptionFailure />}
          ></Route>
          {/* <Route
            path="/MyFirstLand/:categoryUrl"
            element={<Dashboard />}
          ></Route> */}

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminHome />}></Route>

          {/* Education Routes */}
          <Route
            path="/Education/professional-blogs"
            element={<ProBlogList />}
          ></Route>
          <Route
            path="/Education/firstland-blogs"
            element={<FlBlogList />}
          ></Route>
          <Route path="/Education" element={<Edu />}></Route>

          <Route path="/pro-reels" element={<ProReels />}></Route>
          <Route path="/News" element={<NewsView />}></Route>
          <Route path="/Ai+News" element={<NewsAIView />}></Route>
          <Route path="/reset-password" element={<PassResetView />}></Route>
          <Route path="/Agencies" element={<AgencyView />}></Route>
          <Route path="/Terms-and-Conditions" element={<TandCView />}></Route>
          <Route path="/Dashboard" element={<TemplateDashboard />}></Route>
          <Route path="/test" element={<TestView />}></Route>
          <Route path="/realtor-landing" element={<RealtorLanding />}></Route>
          <Route path="/market-info" element={<MarketInfo />}></Route>
          <Route path="/broker-landing" element={<RealtorLanding />}></Route>
          <Route path="/realtor-onbaord" element={<RelatorOnboard />}></Route>
          <Route path="/broker-onbaord" element={<RelatorOnboard />}></Route>
          <Route path="/landlord-landing" element={<LandlordLanding />}></Route>
          <Route path="/landlord-onbaord" element={<LandlordOnboard />}></Route>
          <Route path="/agency-landing" element={<AgnecyLanding />}></Route>
          <Route path="/agency-onbaord" element={<AgencyOnboard />}></Route>
          <Route
            path="/realtor/add-property"
            element={<ProAddListing />}
          ></Route>
          <Route path="/edit-listing/:url" element={<EditListing />} />
          {/* @TODO */}
          {/* <Route
            path="/landlord/add-property"
            element={<landlordAddListing />}
          ></Route> */}
          <Route
            path="/cancel-subscription-confirmed"
            element={<>Subscription cancelled!</>}
          ></Route>
          <Route path="/SelectHouse" element={<SelectHouseView />} />
        </Routes>
      </BrowserRouter>
      {loader && (
        <div className={styles.overlay}>
          <div className={styles.loader}></div>
        </div>
      )}
      <UserLogin />
      <CookiePolicyBanner />
      <GoogleAnalyticsLoader />
      <ToastContainer style={{ width: "50%" }} />
    </>
  );
};
